import { NgClass, NgIf, NgStyle, UpperCasePipe } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

export enum AvatarSize {
  Small = 'w-5 h-5',
  Medium = 'w-10 h-10',
  Large = 'w-16 h-16',
}

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  imports: [NgClass, NgStyle, MatIcon, UpperCasePipe, NgIf],
})
export class AvatarComponent implements OnChanges {
  @Input() public label!: string;
  @Input() public icon!: string;
  @Input() public size = AvatarSize.Medium;
  @Input() public backgroundColor? = 'primary-90';
  @Input() public color? = 'primary-10';

  public avatarLabel!: string;

  public ngOnChanges(): void {
    this.avatarLabel =
      this.label
        ?.match(/\b(\w)/g)
        ?.slice(0, 4)
        .join('') || '';
  }
}
